import axios from "axios";
// 图片上传(带汉王算法)
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const upload = (data: any) => {
  return axios({
    url: process.env.VUE_APP_UPLOAD_API + "/head",
    headers: {
      isToken: false,
      "Content-Type": "multipart/form-data",
    },
    method: "post",
    data,
  });
};

// 图片上传(不带汉王算法)
export const uploadNo = (data: any) => {
  return axios({
    url: process.env.VUE_APP_UPLOAD_API,
    headers: {
      isToken: false,
      "Content-Type": "multipart/form-data",
    },
    method: "post",
    data,
  });
};
